import { createContext } from "react";

export const LabTestContext = createContext({
  labTest: {},
  onChange: () => {},
});
